import {Action} from "@ngrx/store";
import {AccountantMonitorModel} from "@services/back-office/model/accountantMonitorModel";
import { HttpErrorResponse } from "@angular/common/http";
import {PageAccountantMonitorModel} from "@services/back-office/model/pageAccountantMonitorModel";
import {PaginationModel} from "@shared/models/pagination.model";

export enum AccountantMonitorActionTypes {
    LoadAccountantMonitor = '[AccountantMonitor] Load AccountantMonitor',
    LoadAccountantMonitorSuccess = '[AccountantMonitor] Load AccountantMonitor Success',
    LoadAccountantMonitorFailure = '[AccountantMonitor] Load AccountantMonitor Failure',
    SetFilter = '[AccountantMonitor] Set Filter',
    ClearFilter = '[AccountantMonitor] Clear Filter',
    SetInitialState = '[AccountantMonitor] Set Initial State',
    ChangePage = '[AccountantMonitor] Change Page',
    SetInitialPagination = '[AccountantMonitor] Set Initial Pagination',
}

/** Load AccountantMonitor */
export class LoadAccountantMonitor implements Action {
    readonly type = AccountantMonitorActionTypes.LoadAccountantMonitor;
    constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadAccountantMonitorSuccess implements Action {
    readonly type = AccountantMonitorActionTypes.LoadAccountantMonitorSuccess;
    constructor(public payload: PageAccountantMonitorModel) { }
}

export class LoadAccountantMonitorFailure implements Action {
    readonly type = AccountantMonitorActionTypes.LoadAccountantMonitorFailure;
    constructor(public payload: HttpErrorResponse) { }
}

export class ChangePage implements Action {
    readonly type = AccountantMonitorActionTypes.ChangePage;
    constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
    readonly type = AccountantMonitorActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
    readonly type = AccountantMonitorActionTypes.SetFilter;
    constructor(public payload: AccountantMonitorModel) { }
}

/** Clear Filter */
export class ClearFilter implements Action {
    readonly type = AccountantMonitorActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
    readonly type = AccountantMonitorActionTypes.SetInitialState;
}

export type AccountantMonitorActions =
    | LoadAccountantMonitor
    | LoadAccountantMonitorSuccess
    | LoadAccountantMonitorFailure
    | ChangePage
    | SetInitialPagination
    | SetFilter
    | ClearFilter
    | SetInitialState
;
